import { createSlice } from '@reduxjs/toolkit';
import initialState from './transportInitialState';
import {
  _setNewTransportForm,
  _setFundingSTOPBilltoOrganization,
  _setDepartingSAPorJailDepartureLocation,
  _setOrganizationPerformingPickUpInitial,
  _setCommunityProviderFacility,
  _setFundingSTOPContact,
  _setSAPTransitionalCounselor,
  _setPersonPerformingPickInitialDeparture,
  _setPersonReceivingDestination,
  _setSource,
  _setHighControl,
  _setSpecialTransport,
  _setPlanIncludesFlight,
  _setSASCARepresentativeTransportationCoordinator,
  _setTransportCompletedByOrganization,
  _setInitialDepartureDate,
  _setDateSAPConfirmedRelease,
  _setSAPStaffConfirmingRelease,
  _setActualDepartureDate,
  _setOutcome,
  _setWhoContactedConfirmationCallmadeto,
  _setContactedByConfirmationCallmadeby,
  _setCallDate,
  _setCallTime,
  _setStaffTime1By4hrs,
  _setMileage,
  _setEstimatedICDTPFlatFee,
  _setStaffTimeQty,
  _setStaffTimeOverTime,
  _setStaffTimeRate,
  _setStaffTimeAmount,
  _setMileageQty,
  _setMileageRate,
  _setMileageAmount,
  _setICDTPFlatFee,
  _setTotalCombinedActualCosts,
  _setComments,
  _setVoid,
} from './transportActions';

export const transportSlice = createSlice({
  name: 'getTransportForm',
  initialState,
  reducers: {
    getTransportForm: (state, action) => action.payload,
    setNewTransportForm: _setNewTransportForm,
    setFundingSTOPBilltoOrganization: _setFundingSTOPBilltoOrganization,
    setDepartingSAPorJailDepartureLocation:
      _setDepartingSAPorJailDepartureLocation,
    setOrganizationPerformingPickUpInitial:
      _setOrganizationPerformingPickUpInitial,
    setCommunityProviderFacility: _setCommunityProviderFacility,
    setFundingSTOPContact: _setFundingSTOPContact,
    setSAPTransitionalCounselor: _setSAPTransitionalCounselor,
    setPersonPerformingPickInitialDeparture:
      _setPersonPerformingPickInitialDeparture,
    setPersonReceivingDestination: _setPersonReceivingDestination,
    setSource: _setSource,
    setHighControl: _setHighControl,
    setSpecialTransport: _setSpecialTransport,
    setPlanIncludesFlight: _setPlanIncludesFlight,
    setSASCARepresentativeTransportationCoordinator:
      _setSASCARepresentativeTransportationCoordinator,
    setTransportCompletedByOrganization: _setTransportCompletedByOrganization,
    setInitialDepartureDate: _setInitialDepartureDate,
    setDateSAPConfirmedRelease: _setDateSAPConfirmedRelease,
    setSAPStaffConfirmingRelease: _setSAPStaffConfirmingRelease,
    setActualDepartureDate: _setActualDepartureDate,
    setOutcome: _setOutcome,
    setWhoContactedConfirmationCallmadeto:
      _setWhoContactedConfirmationCallmadeto,
    setContactedByConfirmationCallmadeby: _setContactedByConfirmationCallmadeby,
    setCallDate: _setCallDate,
    setCallTime: _setCallTime,
    setStaffTime1By4hrs: _setStaffTime1By4hrs,
    setMileage: _setMileage,
    setEstimatedICDTPFlatFee: _setEstimatedICDTPFlatFee,
    setStaffTimeQty: _setStaffTimeQty,
    setStaffTimeOverTime: _setStaffTimeOverTime,
    setStaffTimeRate: _setStaffTimeRate,
    setStaffTimeAmount: _setStaffTimeAmount,
    setMileageQty: _setMileageQty,
    setMileageRate: _setMileageRate,
    setMileageAmount: _setMileageAmount,
    setICDTPFlatFee: _setICDTPFlatFee,
    setTotalCombinedActualCosts: _setTotalCombinedActualCosts,
    setComments: _setComments,
    setVoid: _setVoid,
    resetTransportForm: () => initialState,

    // Phase 2.1: NEW - Batch update action to reduce Redux dispatches by 98%
    // Updates multiple fields at once instead of 40-50 individual dispatches
    // Backward compatible - all existing actions remain functional
    updateTransportFields: (state, action) => {
      Object.keys(action.payload).forEach(key => {
        if (state.hasOwnProperty(key)) {
          state[key] = action.payload[key];
        }
      });
    },
  },
});

export const {
  getTransportForm,
  setNewTransportForm,
  setFundingSTOPBilltoOrganization,
  setDepartingSAPorJailDepartureLocation,
  setOrganizationPerformingPickUpInitial,
  setCommunityProviderFacility,
  setFundingSTOPContact,
  setSAPTransitionalCounselor,
  setPersonPerformingPickInitialDeparture,
  setPersonReceivingDestination,
  setSource,
  setHighControl,
  setSpecialTransport,
  setPlanIncludesFlight,
  setSASCARepresentativeTransportationCoordinator,
  setTransportCompletedByOrganization,
  setInitialDepartureDate,
  setDateSAPConfirmedRelease,
  setSAPStaffConfirmingRelease,
  setActualDepartureDate,
  setOutcome,
  setWhoContactedConfirmationCallmadeto,
  setContactedByConfirmationCallmadeby,
  setCallDate,
  setCallTime,
  setStaffTime1By4hrs,
  setMileage,
  setEstimatedICDTPFlatFee,
  setStaffTimeQty,
  setStaffTimeOverTime,
  setStaffTimeRate,
  setStaffTimeAmount,
  setMileageQty,
  setMileageRate,
  setMileageAmount,
  setICDTPFlatFee,
  setTotalCombinedActualCosts,
  setComments,
  setVoid,
  resetTransportForm,
  updateTransportFields, // Phase 2.1: NEW batch update action
} = transportSlice.actions;

export default transportSlice.reducer;
